import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { oneKlicks } from '../SDK/oneclick';
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';
import { useAuth } from '../context/AuthContext';
import { encryptId } from '../services/apiService';


const StaffLogin = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login, isLoggedIn, userData } = useAuth();

    useEffect(() => {
        // Check if user is already logged in
        const token = localStorage.getItem('staff_token');
        if (token) {
            navigate('/staff/dashboard');
        }
    }, [navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Authenticate staff user
            // check email is email format or number format
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && !/^\d+$/.test(formData.email)) {
                const tableSchema = '';
                const tableName = 'employees';
                const conditions = {
                    employee_id: formData.email
                };
                const orderBy = 'id DESC';
                const search = {};
                const pagination = {};
                const margedata = [
                    {
                        target_table: 'users',
                        target_column: 'id',
                        target_value: 'staff_id',
                        target_label: 'users'
                    }
                ];
                console.log("checkemply conditions :", conditions);
                const checkemply = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                console.log("checkemply :", checkemply);
                if (checkemply.success && checkemply.data.length > 0) {
                    console.log("checkemply data :", checkemply.data);
                    const employee = checkemply.data[0];
                    if (employee.users.length > 0) {
                        const user = employee.users[0];
                        console.log("user :", user);
                        console.log("ashPassword user login:", user);
                        const hashedPassword = CryptoJS.SHA256(formData.password).toString();
                        console.log("hashPassword :", hashedPassword);
                        if (user.pass === hashedPassword) {
                            // Store authentication data
                            setLoading(false);
                            setError('');
                            // Store authentication data
                            const userData = {
                                id: user.id,
                                email: user.email,
                                user_type: user.user_type,
                                display_name: user.display_name || user.name || user.email
                            };

                            console.log('User data prepared for login:', userData);
                            // Use the login function from AuthContext
                            const loginSuccess = await login(userData);
                            if (loginSuccess) {
                                localStorage.setItem('presentuser', JSON.stringify(userData));
                                toast.success("Login successful!", { autoClose: 2000 });
                                handleNavigation(userData);
                            } else {
                                console.error('Login failed - login function returned false');
                                toast.error("Login failed. Please try again.");
                            }
                        } else {
                            setLoading(false);
                            setError('');
                            setError('Invalid email or password');
                        }
                    } else {
                        setLoading(false);
                        setError('');
                        setError('Invalid email or password');
                    }
                }
            } else {
                const tableSchema = '';
                const tableName = 'users';
                const conditions = {
                    email: formData.email,
                    user_type: 'staff'
                };
                const orderBy = 'id DESC';
                const search = {};
                const pagination = {};
                const margedata = [
                    {
                        target_table: 'employees',
                        target_column: 'staff_id',
                        target_value: 'id',
                        target_label: 'employees'
                    }
                ];
                const checkuser = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                console.log("checkuser :", checkuser);
                if (checkuser.success && checkuser.data.length > 0) {
                    const user = checkuser.data[0];
                    if (user.employees.length > 0) {
                        const employee = user.employees[0];
                        if (employee.status === 'active') {
                            const hashPassword = CryptoJS.SHA256(formData.password).toString();
                            console.log("hashPassword :", hashPassword);
                            if (user.pass === hashPassword) {
                                // Store authentication data
                                const userData = {
                                    id: user.id,
                                    email: user.email,
                                    user_type: user.user_type,
                                    display_name: user.display_name || user.name || user.email
                                };

                                console.log('User data prepared for login:', userData);
                                // Use the login function from AuthContext
                                const loginSuccess = await login(userData);
                                if (loginSuccess) {
                                    localStorage.setItem('presentuser', JSON.stringify(userData));
                                    toast.success("Login successful!", { autoClose: 2000 });
                                    handleNavigation(userData);
                                } else {
                                    console.error('Login failed - login function returned false');
                                    toast.error("Login failed. Please try again.");
                                }
                            } else {
                                setLoading(false);
                                setError('');
                                setError('Invalid email or password');
                            }
                        } else {
                            setLoading(false);
                            setError('');
                            setError('Invalid email or password');
                        }
                    } else {
                        setLoading(false);
                        setError('');
                        setError('Invalid email or password');
                    }
                }
            }

        } catch (error) {
            console.error('Login error:', error);
            setLoading(false);
            setError('');
            setError('Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleNavigation = (userData) => {
        setTimeout(() => {
            switch (userData.user_type?.toLowerCase()) {
                case "admin":
                    navigate("/admin-dashboard");
                    break;
                case "doctor":
                    navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                    break;
                case "hospitals":
                    navigate("/hospital/dashboard");
                    break;
                case "regular_users":
                    navigate("/user-dashboard");
                    break;
                case "patient":
                    navigate("/user-dashboard");
                    break;
                case "pharmacy":
                    navigate("/pharmacy/dashboard");
                    break;
                case "user":
                    // Stay on home page - user can access dashboard from header dropdown
                    navigate("/");
                    break;
                case "administrator":
                    navigate("/superadmin/dashboard");
                    break;
                case "staff":
                    navigate("/staff/dashboard");
                    break;
                case "editor":
                    navigate("/editor/dashboard");
                    break;
                default:
                    // For unknown roles, stay on home page
                    navigate("/");
                    break;
            }
        }, 1500);
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100%',
            padding: '20px'
        }}>
            <Row className="justify-content-center wl-100" style={{ margin: 0 }}>
                <Col xs={12} sm={10} md={8} lg={5} xl={4}>
                    <Card style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                        <Card.Body className="p-4">
                            <div className="text-center mb-4">
                                <div className="staff-logo">
                                    <i className="fas fa-user-shield fa-3x text-primary"></i>
                                </div>
                                <h3 className="mt-3 mb-1">Staff Portal</h3>
                                <p className="text-muted">Employee Activity Tracking</p>
                            </div>

                            {error && (
                                <Alert variant="danger" className="mb-3">
                                    {error}
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="Enter your email or employee id"
                                        required
                                        disabled={loading}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        placeholder="Enter your password"
                                        required
                                        disabled={loading}
                                    />
                                </Form.Group>

                                <div className="justify-content-between d-flex">
                                    <div className="form-check wl-50">
                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                        <p className="form-check-label mb-0" htmlFor="flexCheckDefault">
                                            Remember me
                                        </p>
                                    </div>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        size="lg"
                                        className="w-100 mb-3"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Signing In...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-sign-in-alt me-2"></i>
                                                Sign In
                                            </>
                                        )}
                                    </Button>
                                </div>


                            </Form>

                            <div className="text-center">
                                <small className="text-muted">
                                    Demo Credentials: staff@company.com / staff123
                                </small>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default StaffLogin;
